import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const findByEmailAddress = (emailAddress: string): AxiosPromise =>
  instance.post('/api/visitors/byEmail', { emailAddress });

export default findByEmailAddress;
